module.exports = __webpack_public_path__ + "img/20211220.82922c37.png";